import { V004Algorithm } from '../../../../Algorithm';
import { ProtocolVersion } from '@standardnotes/common';
import { DeriveRootKeyUseCase } from './DeriveRootKey';
import { Create004KeyParams } from '../../../../Keys/RootKey/KeyParamsFunctions';
export class CreateRootKeyUseCase {
    constructor(crypto) {
        this.crypto = crypto;
    }
    async execute(identifier, password, origination) {
        const version = ProtocolVersion.V004;
        const seed = this.crypto.generateRandomKey(V004Algorithm.ArgonSaltSeedLength);
        const keyParams = Create004KeyParams({
            identifier: identifier,
            pw_nonce: seed,
            version: version,
            origination: origination,
            created: `${Date.now()}`,
        });
        const usecase = new DeriveRootKeyUseCase(this.crypto);
        return usecase.execute(password, keyParams);
    }
}
